import { render } from "./nav-item.vue?vue&type=template&id=6279a561&scoped=true"
import script from "./nav-item.vue?vue&type=script&lang=js"
export * from "./nav-item.vue?vue&type=script&lang=js"

import "./nav-item.vue?vue&type=style&index=0&id=6279a561&lang=less&scoped=true"

import exportComponent from "/home/runner/work/suplasercut-admin/suplasercut-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6279a561"]])

export default __exports__